import { Col, Row, Image } from "react-bootstrap";
import Default from "./layout/Default";
import LoginImage from "../assets/images/login-img.png";
import LoginForm from "../components/Login/LoginForm";
import { Link, useNavigate } from "react-router-dom";
import { Form, Button, Alert } from "react-bootstrap";

const Login = () => {
  return (
    <>
      <Default>
        <Row className="loginPage">
          <Col md="6" className="imgLogo mt-4">
            <h2 className="text-center">
              <span>Welcome to </span>
              <br /> Virtu Ward{" "}
            </h2>
            <br></br>
            <Image className="mt-5" src={LoginImage} alt="" />
          </Col>
          <Col md="6" className="mt-md-2 mb-4 loginForm">
            <LoginForm />
          </Col>
        </Row>
      </Default>
     
    </>
  );
};

export default Login;
